import { useEffect, useContext } from 'react';
import './App.scss';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import { Content, InlineLoading, InlineNotification } from 'carbon-components-react';
import axios from 'axios';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import ShellHeader from './components/ShellHeader/ShellHeader';
import ShellFooter from './components/ShellFooter/ShellFooter';
import SettingsPage from './pages/SettingsPage/SettingsPage';
import UserContext from './UserContext';

const redirectToLogin = () => {
  const currentUrl = window.location.href;
  window.location.href = `/api/sso-login?redirect_to=${encodeURIComponent(currentUrl)}`;
};

function App() {
  const {isLoggedIn, user, setLoggedInUser} = useContext(UserContext);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const { data: userData } = await axios.get('/api/me');
        if (userData) {
          setLoggedInUser(userData);
        } else {
          redirectToLogin();
        }
      } catch (err) {
        setLoggedInUser(null);
        redirectToLogin();
      }
    };

    fetchUser();
  }, [setLoggedInUser]);

  const message = (
    <div className="bannerMessage">
      <h5>Important Notice</h5>
      <p>The remaining functionality of Ideas Hub has reached End of Life (EOL).</p>
      <p>Teams can use <a target="_blank" href="https://bigblue.aha.io/shared/e03872f9759a9f0a93d353429f65298a" rel="noreferrer"> ibm.biz/portfolio_SLA_View</a> for SLA reporting.</p>
      <p>Guidance on additional options can be found <a target="_blank" href="https://w3.ibm.com/support/aha-at-ibm-playbook/#/documents/c965fd00-8d99-479c-b670-4c28329b94cb" rel="noreferrer">here</a></p>
    </div>
  );
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        {isLoggedIn ? (
          <>
            <ShellHeader user={user} />
            <div className="headerBanner">
              <InlineNotification
                className="warningMessage"
                kind="info"
                title=""
                subtitle={message}
                lowContrast
              />
            </div>
            <Content>
              <Switch>
                {/* <Route path="/ideas">
                  <IdeasPage />
                </Route>
                <Route path="/business-unit-summary/:utcode">
                  <BusinessUnitPage />
                </Route>
                <Route path="/business-unit-summary">
                  <BusinessUnitSummaryPage />
                </Route>
                <Route path="/settings">
                  <SettingsPage />
                </Route>
                <Route path="/support">
                  <SupportPage />
                </Route>
                <Route path="/terms-and-conditions">
                  <TermsAndConditionsPage />
                </Route>
                <Route path="/slack-response">
                  <SlackResponsePage />
                </Route> */}
                <Redirect from="/" to="/ideas/summary" exact />
                {/* Always render SettingsPage */}
                <Route path="/settings">
                  <SettingsPage />
                </Route>

                {/* Redirect all other routes to /settings */}
                <Redirect to="/settings" />
              </Switch>
            </Content>
            <ShellFooter />
          </>
        ) : (
          <div className="logging-in">
            <InlineLoading />
            Logging in...
          </div>
        )}
      </div>
    </Router>
  );
}

export default App;
